let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Aside = require('ES/widgets/Aside');
let ErrorAlert = require('ES/widgets/ErrorAlert');
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let SearchForm = require('./SearchForm');
let LoadingWrap = require('ES/widgets/LoadingWrap');
let SearchResult = require('./SearchResult');
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let FormUtils = require('../../../utils/FormUtils');

let SearchResults = dd.createClass({
	render(){
		let {my_speaker_names_by_sid, results} = this.props;

		if (_.size(results) === 0) {
			return dd.h4({className: 'text-center emptylist', style: {margin: '30px 0'}}, 'No matches. Try a different search.');
		}

		return dd.div({style: {margin: '10px 0'}},
			_.map(results, function (result, i) {
				return SearchResult({key: result.eid + ',' + i, result, my_speaker_names_by_sid});
			})
		);
	}
});

let DaAside = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			EventSearch_search: {
				key(){
					return JSON.stringify(this.props.query);
				}
			}
		};
	},
	render(){
		let ajax = this.state.EventSearch_search;
		let {query, onClose, Displaylists} = this.props;

		let my_speaker_names_by_sid = FormUtils.getSpeakerNamesBySid(Displaylists, true);
		let preferences = (Displaylists && Displaylists.user && Displaylists.user.myevents_preferences) || {};
		let results = _.isArray(ajax.data) ? ajax.data : [];

		if ((preferences.sort_results === 'earliest_at_top') && !(query && (query.parenteid > 0))) {//don't reverse it on family searches
			//DON't use results.reverse() b/c that will reverse on every render, mutating the underlying ajax data every time
			results = _.sortBy(results, function (val, i) {//sortBy doesn't mutate the original array
				return -i;//reverse
			});
		}

		return Aside({
				header: [
					dd.h4({key: 1}, 'Search EventCX'),
					SearchForm({
						key: 2,
						mini_form: false,
						query,
						results,
						loading: ajax.waiting,
						error_msg: ajax.error,
						my_speaker_names_by_sid
					})
				],
				right: true,
				__onClose: onClose
			},
			ErrorAlert({message: ajax.error}),
			LoadingWrap({is_loading: ajax.waiting, text: 'Searching...'},
				!ajax.error && !_.isArray(ajax.data)
					? dd.h4({className: 'text-center', style: {margin: '30px 0'}}, "What would you like to search?")
					: SearchResults({results, my_speaker_names_by_sid})
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {show: false, query: null};
	},
	Radio_setup(){
		return {
			EventSearchAside_search(query){
				this.setState({show: true, query}, function () {
					radio("EventSearch_search").broadcast(query);
				});
			},
			EventSearchAside_open(){
				if (!this.state.show) {
					this.setState({show: true, query: null});
				}
			}
		};
	},
	__onClose(){
		this.setState({show: false});
	},
	render(){
		if (!this.state.show) {
			return dd.div();
		}

		return DaAside({
			query: this.state.query,
			onClose: this.__onClose,
			Displaylists: this.props.Displaylists
		});
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/EventSearchAside.js